"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegistriesData = exports.getAccountIDs = exports.getRegion = exports.isPubECR = exports.isECR = void 0;
const core = __importStar(require("@actions/core"));
const client_ecr_1 = require("@aws-sdk/client-ecr");
const client_ecr_public_1 = require("@aws-sdk/client-ecr-public");
const node_http_handler_1 = require("@smithy/node-http-handler");
const http_proxy_agent_1 = require("http-proxy-agent");
const https_proxy_agent_1 = require("https-proxy-agent");
const ecrRegistryRegex = /^(([0-9]{12})\.dkr\.ecr\.(.+)\.amazonaws\.com(.cn)?)(\/([^:]+)(:.+)?)?$/;
const isECR = (registry) => {
    return ecrRegistryRegex.test(registry) || (0, exports.isPubECR)(registry);
};
exports.isECR = isECR;
const isPubECR = (registry) => {
    return registry === 'public.ecr.aws';
};
exports.isPubECR = isPubECR;
const getRegion = (registry) => {
    if ((0, exports.isPubECR)(registry)) {
        return process.env.AWS_REGION || process.env.AWS_DEFAULT_REGION || 'us-east-1';
    }
    const matches = registry.match(ecrRegistryRegex);
    if (!matches) {
        return '';
    }
    return matches[3];
};
exports.getRegion = getRegion;
const getAccountIDs = (registry) => {
    if ((0, exports.isPubECR)(registry)) {
        return [];
    }
    const matches = registry.match(ecrRegistryRegex);
    if (!matches) {
        return [];
    }
    const accountIDs = [matches[2]];
    if (process.env.AWS_ACCOUNT_IDS) {
        accountIDs.push(...process.env.AWS_ACCOUNT_IDS.split(','));
    }
    return accountIDs.filter((item, index) => accountIDs.indexOf(item) === index);
};
exports.getAccountIDs = getAccountIDs;
const getRegistriesData = (registry, username, password) => __awaiter(void 0, void 0, void 0, function* () {
    const region = (0, exports.getRegion)(registry);
    const accountIDs = (0, exports.getAccountIDs)(registry);
    const authTokenRequest = {};
    if (accountIDs.length > 0) {
        core.debug(`Requesting AWS ECR auth token for ${accountIDs.join(', ')}`);
        authTokenRequest['registryIds'] = accountIDs;
    }
    let httpProxyAgent;
    const httpProxy = process.env.http_proxy || process.env.HTTP_PROXY || '';
    if (httpProxy) {
        core.debug(`Using http proxy ${httpProxy}`);
        httpProxyAgent = new http_proxy_agent_1.HttpProxyAgent(httpProxy);
    }
    let httpsProxyAgent;
    const httpsProxy = process.env.https_proxy || process.env.HTTPS_PROXY || '';
    if (httpsProxy) {
        core.debug(`Using https proxy ${httpsProxy}`);
        httpsProxyAgent = new https_proxy_agent_1.HttpsProxyAgent(httpsProxy);
    }
    const credentials = username && password
        ? {
            accessKeyId: username,
            secretAccessKey: password
        }
        : undefined;
    if ((0, exports.isPubECR)(registry)) {
        core.info(`AWS Public ECR detected with ${region} region`);
        const ecrPublic = new client_ecr_public_1.ECRPUBLIC({
            customUserAgent: 'docker-login-action',
            credentials,
            region: region,
            requestHandler: new node_http_handler_1.NodeHttpHandler({
                httpAgent: httpProxyAgent,
                httpsAgent: httpsProxyAgent
            })
        });
        const authTokenResponse = yield ecrPublic.getAuthorizationToken(authTokenRequest);
        if (!authTokenResponse.authorizationData || !authTokenResponse.authorizationData.authorizationToken) {
            throw new Error('Could not retrieve an authorization token from AWS Public ECR');
        }
        const authToken = Buffer.from(authTokenResponse.authorizationData.authorizationToken, 'base64').toString('utf-8');
        const creds = authToken.split(':', 2);
        core.setSecret(creds[0]); // redacted in workflow logs
        core.setSecret(creds[1]); // redacted in workflow logs
        return [
            {
                registry: 'public.ecr.aws',
                username: creds[0],
                password: creds[1]
            }
        ];
    }
    else {
        core.info(`AWS ECR detected with ${region} region`);
        const ecr = new client_ecr_1.ECR({
            customUserAgent: 'docker-login-action',
            credentials,
            region: region,
            requestHandler: new node_http_handler_1.NodeHttpHandler({
                httpAgent: httpProxyAgent,
                httpsAgent: httpsProxyAgent
            })
        });
        const authTokenResponse = yield ecr.getAuthorizationToken(authTokenRequest);
        if (!Array.isArray(authTokenResponse.authorizationData) || !authTokenResponse.authorizationData.length) {
            throw new Error('Could not retrieve an authorization token from AWS ECR');
        }
        const regDatas = [];
        for (const authData of authTokenResponse.authorizationData) {
            const authToken = Buffer.from(authData.authorizationToken || '', 'base64').toString('utf-8');
            const creds = authToken.split(':', 2);
            core.setSecret(creds[0]); // redacted in workflow logs
            core.setSecret(creds[1]); // redacted in workflow logs
            regDatas.push({
                registry: authData.proxyEndpoint || '',
                username: creds[0],
                password: creds[1]
            });
        }
        return regDatas;
    }
});
exports.getRegistriesData = getRegistriesData;
